import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subscription, interval } from 'rxjs';
import { CountDownOptions } from './models/count-down-options';

@Component({
    selector: 'app-count-down',
    templateUrl: './count-down.component.html',
    styleUrls: ['./count-down.component.scss'],
    imports: []
})
export class CountDownComponent implements OnInit, OnDestroy {
    /**
     * Constantes
     */
    milliSecondsInASecond = 1000;
    hoursInADay = 24;
    minutesInAnHour = 60;
    SecondsInAMinute = 60;

    /**
     * Date d'expiration.
     */
    @Input()
    public expirationDate: Date;

    /**
     * Options d'affichage du compteur.
     */
    @Input()
    options: CountDownOptions;

    /**
     * Emis lorsque le compteur arrive à 0.
     */
    @Output()
    public finished: EventEmitter<boolean> = new EventEmitter();

    /**
     * Souscription aux événements émis toutes les secondes.
     */
    private subscription: Subscription;

    /**
     * Temps restant avant expiration (en secondes).
     */
    public remainingTime = 0;

    /**
     * Nombre de secondes affichées par le compteur.
     */
    public counterSeconds;

    /**
     * Nombre de minutes affichées par le compteur.
     */
    public counterMinutes;

    /**
     * Nombre d'heures affichées par le compteur.
     */
    public counterHours;

    /**
     * Nombre de jours affichées par le compteur.
     */
    public counterDays;

    /**
     * Appelée à l'initialisation du composant.
     */
    ngOnInit() {
        this.subscription = interval(1000).subscribe((x) => {
            this.calculateRemainingTime();
        });
    }

    /**
     * Appelée à la destruction du composant.
     */
    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    /**
     * Calcule le temps restant avant expiration.
     */
    private calculateRemainingTime() {
        if (this.expirationDate) {
            this.remainingTime = this.expirationDate.getTime() - new Date().getTime();
            this.allocateTimeUnits(this.remainingTime);

            if (this.remainingTime <= 0) {
                this.finished.emit(true);
            }
        }
    }

    /**
     * Détermine la valeur de chaque unités du compteur.
     * @param remainingTime : Temps restant avant expiration (en secondes).
     */
    private allocateTimeUnits(remainingTime) {
        this.counterSeconds = Math.floor((remainingTime / this.milliSecondsInASecond) % this.SecondsInAMinute);
        this.counterMinutes = Math.floor((remainingTime / (this.milliSecondsInASecond * this.minutesInAnHour)) % this.SecondsInAMinute);
        this.counterHours = Math.floor((remainingTime / (this.milliSecondsInASecond * this.minutesInAnHour * this.SecondsInAMinute)) % this.hoursInADay);
        this.counterDays = Math.floor(remainingTime / (this.milliSecondsInASecond * this.minutesInAnHour * this.SecondsInAMinute * this.hoursInADay));
    }
}
